
export const filterAllData = (obj: any, reportedStatus: string) => {
  const AllData = obj.enclosurePOReports;
  if (obj.filterType === 'All') {
    if (reportedStatus === "inProgress") {
      return AllData.filter((val: any) => {
        return val.completed !== "1";
      });
    }
    else {
      return AllData.filter((val: any) => {
        return val.completed === "1";
      });
    }
  } else if (obj.filterType === 'coloSign') {
    return filterColoSignData(AllData, reportedStatus)

  } else if (obj.filterType === 'kenRay') {
    return filterKenRayData(AllData, reportedStatus)

  } else if (obj.filterType === 'boydSigns') {
    return filterBoydSignsData(AllData, reportedStatus)

  } else if (obj.filterType === 'temporary') {
    return filterTemporaryData(AllData, reportedStatus)

  } else if (obj.filterType === 'allDelivered') {
    return filterAllDeliveredData(AllData, reportedStatus)

  }

}

export const filterColoSignData = (SignData: any, reportedStatus: any) => {
  if (reportedStatus === "inProgress") {
    return SignData.filter((val: any) => {
      return val.vendor === 'CS' && val.completed !== "1";
    });
  }
  else {
    return SignData.filter((val: any) => {
      return val.vendor === 'CS' && val.completed === "1";
    });
  }
}

export const filterKenRayData = (kenRayData: any, reportedStatus: any) => {
  if (reportedStatus === "inProgress") {
    return kenRayData.filter((val: any) => {
      return val.vendor === 'KR' && val.completed !== "1";
    });
  }
  else {
    return kenRayData.filter((val: any) => {
      return val.vendor === 'KR' && val.completed === "1";
    });
  }
}

export const filterBoydSignsData = (BodySignsData: any, reportedStatus: any) => {
  if (reportedStatus === "inProgress") {
    return BodySignsData.filter((val: any) => {
      return val.vendor === 'Boyd' && val.completed !== "1";
    });
  }
  else {
    return BodySignsData.filter((val: any) => {
      return val.vendor === 'Boyd' && val.completed === "1";
    });
  }
}


export const filterTemporaryData = (TempData: any, reportedStatus: any) => {
  if (reportedStatus === "inProgress") {
    return TempData.filter((val: any) => {
      return val.vendor === 'Temp' && val.completed !== "1";
    });
  }
  else {
    return TempData.filter((val: any) => {
      return val.vendor === 'Temp' && val.completed === "1";
    });
  }
}


export const filterAllDeliveredData = (AllDeliveredData: any, reportedStatus: any) => {
  if (reportedStatus === "inProgress") {
    return AllDeliveredData.filter((val: any) => {
      return val.received === '1' && val.completed !== "1";
    });
  } else {
    return AllDeliveredData.filter((val: any) => {
      return val.received === '1' && val.completed === "1";
    });
  }
}


// WEBPACK FOOTER //
// ./src/store/enclosurePO/enclouserPOFilters.ts